const opcionesAplica = [
  { id: true, label: 'Aplica' },
  { id: false, label: 'No Aplica' },
];

export default opcionesAplica;
